import {LLAVEPUBLICA, MONEDA, URLRECIBO} from "../Constantes";
import {useEffect, useRef, useState} from "react";
import {obtenerHash} from "../Funciones/obtenerHash";

export const usePagoWompi = () => {
    const refe = useRef(null)
    const [fechaExpiracion, setFechaExpiracion] = useState('')
    const [hash, setHash] = useState('')
    const [valor, setValor] = useState(0)
    const [idVenta, setIdVenta] = useState('')
    const [correo, setCorreo] = useState('')
    const [direccion, setDireccion] = useState('')
    const [cc, setCC] = useState('')
    const [celular, setCelular] = useState('')
    const [nombre, setNombre] = useState('')

    const pagar = ({valor, idVenta, correo, direccion, cc, celular, nombre}) => {


        setValor(valor)
        setIdVenta(idVenta)
        setCorreo(correo)
        setDireccion(direccion)
        setCelular(celular)
        setCC(cc)
        setNombre(nombre)
        let fecha = new Date()
        let dosHora = new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate(), fecha.getHours() + 2, 0, 0)
        let fechaEx = dosHora.toISOString()
        setFechaExpiracion(fechaEx)

        obtenerHash({idVenta: idVenta, valor: valor, fechaExpiracion: fechaEx, moneda: MONEDA}).then((dox) => {
            setHash(dox)

        })
    }

    useEffect(() => {
        if (hash !== '') {
            refe.current.click()
        }
    }, [hash]);

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://checkout.wompi.co/widget.js";
        script.async = true;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };


    }, []);
    const BotonNoVisible = () => {

        return (
            <form action="https://checkout.wompi.co/p/" method="GET">

                <input type="hidden" name="public-key" value={LLAVEPUBLICA}/>
                <input type="hidden" name="currency" value={MONEDA}/>
                <input type="hidden" name="amount-in-cents" value={valor}/>
                <input type="hidden" name="reference" value={idVenta}/>
                <input type="hidden" name="signature:integrity" value={hash}/>
                <input type="hidden" name="redirect-url" value={URLRECIBO}/>
                <input type="hidden" name="expiration-time" value={fechaExpiracion}/>
                <input type="hidden" name="tax-in-cents:vat" value="0"/>
                <input
                    type="hidden"
                    name="tax-in-cents:consumption"
                    value="0"
                />
                <input type="hidden" name="customer-data:email" value={correo}/>
                <input
                    type="hidden"
                    name="customer-data:full-name"
                    value={nombre}
                />
                <input
                    type="hidden"
                    name="customer-data:phone-number"
                    value={celular}
                />
                <input
                    type="hidden"
                    name="customer-data:legal-id"
                    value={cc}
                />
                <input
                    type="hidden"
                    name="customer-data:legal-id-type"
                    value="CC"
                />
                <input
                    type="hidden"
                    name="shipping-address:address-line-1"
                    value={direccion}
                />
                <input type="hidden" name="shipping-address:country" value="CO"/>
                <input
                    type="hidden"
                    name="shipping-address:phone-number"
                    value={celular}
                />
                <input type="hidden" name="shipping-address:city" value="Bogota"/>
                <input type="hidden" name="shipping-address:region" value="Bogota"/>
                <button
                    ref={refe}
                    style={{display: 'none'}}
                    type="submit">Pagar con Wompi
                </button>
            </form>
        )
    }

    return {
        BotonNoVisible,
        pagar
    }
}